var map = {
	"./data-goods.svg": "0ec4",
	"./data-money.svg": "43ee",
	"./data-order.svg": "526d",
	"./data-user.svg": "66f3",
	"./del-hover.svg": "6c45",
	"./del-normal.svg": "165e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59ea";